/*==================================================
=      RENDER HASIL PERTUMBUHAN WHO 0–5 TAHUN
==================================================*/

function getBadgeClass(category) {

    switch (category) {

        case "Berat Badan Ideal":
        case "Normal":
        case "Tinggi Badan Normal":
        case "Berat Badan Normal":
        case "Lingkar Kepala Normal":

            return "badge-green";

        case "Berisiko Kelebihan Berat Badan":
        case "Tinggi":

            return "badge-yellow";

        case "Kelebihan Berat Badan":

            return "badge-orange";

        case "Obesitas":
        case "Sangat Tinggi":

            return "badge-red";

        default:

            return "badge-blue";

    }

}

function createGrowthCard(
    title,
    result,
    unit
) {

    if (!result) {
        return "";
    }

    return `
        <div class="growth-card">

            <h4>${title}</h4>

            <div class="growth-value">
                ${result.value.toFixed(1)} ${unit}
            </div>

            <div class="growth-category ${getBadgeClass(result.category)}">
                ${result.category}
            </div>

            <div class="growth-stat">
                <strong>Skor-Z:</strong>
                ${result.z.toFixed(2)}
            </div>

            <div class="growth-stat">
                <strong>Persentil:</strong>
                ${result.percentile.toFixed(1)}%
            </div>

            <div class="growth-advice">
                ${result.advice}
            </div>

        </div>
    `;

}

function updateGrowth05UI(results) {

    const slides =
        document.querySelectorAll(
            "#growth-slider .growth-slide"
        );

    if (!slides.length) {
        return;
    }

    const slideData = [
        {
            chart: "height",
            title: "Tinggi Badan Menurut Usia",
            result: results.height,
            unit: "cm"
        },
        {
            chart: "weight",
            title: "Berat Badan Menurut Usia",
            result: results.weight,
            unit: "kg"
        },
        {
            chart: "head",
            title: "Lingkar Kepala Menurut Usia",
            result: results.head,
            unit: "cm"
        },
        {
            chart: "proportion",
            title: results.weightLength
                ? "Berat Badan Menurut Panjang Badan"
                : "Berat Badan Menurut Tinggi Badan",
            result:
                results.weightLength ||
                results.weightHeight,
            unit: "kg"
        }
    ];

    slides.forEach(function (slide, index) {

        const item =
            slideData[index];

        if (
            !item ||
            !item.result
        ) {

            slide.style.display =
                "none";

            slide.innerHTML =
                "";

            return;

        }

        slide.style.display =
            "block";

        slide.innerHTML = `
            <div class="growth-slide-card">

                ${createGrowthCard(
                    item.title,
                    item.result,
                    item.unit
                )}

                <div class="growth-slide-chart">

                    <h4 class="growth-slide-chart-title">
                        Grafik ${item.title}
                    </h4>

                    <canvas
                        id="growth-chart-${item.chart}">
                    </canvas>

                </div>

            </div>
        `;

    });

    initializeGrowthSlider();

}

let currentGrowthSlide = 0;

function getVisibleGrowthSlides() {

    const slider =
        document.getElementById(
            "growth-slider"
        );

    if (!slider) {
        return [];
    }

    return Array.from(
        slider.querySelectorAll(
            ".growth-slide"
        )
    ).filter(function (slide) {

        return (
            slide.style.display !==
            "none"
        );

    });

}

function initializeGrowthSlider() {

    const slider =
        document.getElementById(
            "growth-slider"
        );

    const prev =
        document.getElementById(
            "growth-prev"
        );

    const next =
        document.getElementById(
            "growth-next"
        );

    if (
        !slider ||
        !prev ||
        !next
    ) {
        return;
    }

    const visibleSlides =
        getVisibleGrowthSlides();

    if (!visibleSlides.length) {

        prev.style.display =
            "none";

        next.style.display =
            "none";

        buildGrowthDots(0);

        return;

    }

    const hasMultipleSlides =
        visibleSlides.length > 1;

    prev.style.display =
        hasMultipleSlides
            ? ""
            : "none";

    next.style.display =
        hasMultipleSlides
            ? ""
            : "none";

    currentGrowthSlide =
        0;

    buildGrowthDots(
        visibleSlides.length
    );

    showGrowthSlide(
        currentGrowthSlide,
        visibleSlides
    );

    prev.onclick = function () {

        if (!hasMultipleSlides) {
            return;
        }

        currentGrowthSlide =
            (
                currentGrowthSlide -
                1 +
                visibleSlides.length
            ) %
            visibleSlides.length;

        showGrowthSlide(
            currentGrowthSlide,
            visibleSlides
        );

    };

    next.onclick = function () {

        if (!hasMultipleSlides) {
            return;
        }

        currentGrowthSlide =
            (
                currentGrowthSlide +
                1
            ) %
            visibleSlides.length;

        showGrowthSlide(
            currentGrowthSlide,
            visibleSlides
        );

    };

    let touchStartX = 0;

    slider.ontouchstart = function (event) {

        if (
            !hasMultipleSlides ||
            !event.touches.length
        ) {
            return;
        }

        touchStartX =
            event.touches[0].clientX;

    };

    slider.ontouchend = function (event) {

        if (
            !hasMultipleSlides ||
            !event.changedTouches.length
        ) {
            return;
        }

        const touchEndX =
            event.changedTouches[0].clientX;

        const difference =
            touchEndX -
            touchStartX;

        if (
            Math.abs(difference) <
            50
        ) {
            return;
        }

        if (difference < 0) {

            next.click();

        } else {

            prev.click();

        }

    };

}

function showGrowthSlide(
    index,
    slides
) {

    if (
        !slides ||
        !slides.length ||
        !slides[index]
    ) {
        return;
    }

    slides.forEach(
        function (
            slide,
            slideIndex
        ) {

            slide.style.display =
                slideIndex === index
                    ? "block"
                    : "none";

        }
    );

    updateGrowthDots(index);

    const chartType =
        slides[index].dataset.chart;

    if (
        typeof drawGrowthSlideChart ===
        "function"
    ) {

        drawGrowthSlideChart(
            chartType
        );

    }

}

function buildGrowthDots(count) {

    const dots =
        document.getElementById(
            "growth-slider-dots"
        );

    if (!dots) {
        return;
    }

    dots.innerHTML =
        "";

    if (count <= 1) {
        return;
    }

    for (
        let index = 0;
        index < count;
        index++
    ) {

        const button =
            document.createElement(
                "button"
            );

        button.type =
            "button";

        button.className =
            "growth-slider-dot";

        button.setAttribute(
            "aria-label",
            `Tampilkan penilaian ke-${index + 1}`
        );

        button.addEventListener(
            "click",
            function () {

                const visibleSlides =
                    getVisibleGrowthSlides();

                if (
                    !visibleSlides[index]
                ) {
                    return;
                }

                currentGrowthSlide =
                    index;

                showGrowthSlide(
                    index,
                    visibleSlides
                );

            }
        );

        dots.appendChild(
            button
        );

    }

}

function updateGrowthDots(activeIndex) {

    document
        .querySelectorAll(
            ".growth-slider-dot"
        )
        .forEach(
            function (
                dot,
                index
            ) {

                dot.classList.toggle(
                    "active",
                    index === activeIndex
                );

            }
        );

}